import { memo as Memo } from 'react'

//* Components
import Image from 'components/common/Image'
import Video from 'components/common/Video'

//* Style
import EqualTwoStyle from './style'

const EqualTwo = Memo(({ className, left_file, right_file }) => {
	return (
		<EqualTwoStyle className={`${className || ''}`}>
			<div className={`equalTwoWrap`}>
				<div className={`col-50`}>
					{left_file.type === 'image' ? (
						<Image priority src={left_file.url} alt={left_file.alt} />
					) : (
						<Video src={left_file.url} autoplay={true} loop={true} />
					)}
				</div>
				<div className={`col-50`}>
					{right_file.type === 'image' ? (
						<Image priority src={right_file.url} alt={right_file.alt} />
					) : (
						<Video src={right_file.url} autoplay={true} loop={true} />
					)}
				</div>
			</div>
		</EqualTwoStyle>
	)
})

export default EqualTwo
